import { queryOTA,insertOTA,updateOTA,deleteOTA,publishOTA,cancelOTA } from "../../api/config/modules/OTAManagement";

const state = {
    queryOTA: {},
    insertOTA: {},
    updateOTA: {},
    deleteOTA: {},
    publishOTA: {},
    cancelOTA: {}
};

const mutations = {
  SET_QUERYOTA: (state, queryOTA) => {
    state.queryOTA = queryOTA;
  },
  SET_INSERTOTA: (state, insertOTA) => {
    state.insertOTA = insertOTA;
  },
  SET_UPDATEOTA: (state, updateOTA) => {
    state.updateOTA = updateOTA;
  },
  SET_DELETEOTA: (state, deleteOTA) => {
    state.deleteOTA = deleteOTA;
  },
  SET_PUBLISHOTA: (state, publishOTA) => {
    state.publishOTA = publishOTA;
  },
  SET_CANCELOTA: (state, cancelOTA) => {
    state.cancelOTA = cancelOTA;
  },
};

const actions = {
  GET_QUERYOTA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryOTA(data)
        .then((res) => {
          commit("SET_QUERYOTA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTOTA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertOTA(data)
        .then((res) => {
          commit("SET_INSERTOTA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEOTA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateOTA(data)
        .then((res) => {
          commit("SET_UPDATEOTA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEOTA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteOTA(data)
        .then((res) => {
          commit("SET_DELETEOTA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_PUBLISHOTA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        publishOTA(data)
        .then((res) => {
          commit("SET_PUBLISHOTA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CANCELOTA: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        cancelOTA(data)
        .then((res) => {
          commit("SET_CANCELOTA", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
